import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { EmployeeService } from '../../employee/employee.service';
import { functionpermission, GetTaxListBO, saveTaxPercentageBO } from '../taxs-details.modal';
import { TPService } from './taxs-percent.service';
import { TaskPercentDateService } from './taxs-percentdateservice';
@Component({
  selector: 'app-taxs-percent',
  templateUrl: './taxs-percent.component.html',
  styleUrls: ['./taxs-percent.component.scss']
})
export class TaxsPercentComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridTaxPercent') public gridTaxPercent: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public formatOptions: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  saveTaxPercentageInfo: saveTaxPercentageBO = new saveTaxPercentageBO();
  TaxPercentFilter: GetTaxListBO = new GetTaxListBO();
  isSaveorUpdateBoolean:boolean=false;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: true,
    editableDateField: true
  };
  TaskPercentdropdown: any = [];

  constructor(public DateListService: TaskPercentDateService,
    public service: TPService,
    public employee: EmployeeService,
    public datepipe: DatePipe,
    public dateservice: DateService,
    public global: GlobalComponent, public toasterservice: ToastrService) {
    this.GridList = DateListService;
  }

  fp: functionpermission = new functionpermission()
  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.TaxPercentFilter.field = "taxName";
    this.TaxPercentFilter.orderColumn = "taxName";
    this.getTaxPercentFilter();
    this.GetTaxListDD();
  }

  // ................................................dataChangeTaxPercent..............................................
  public dataChangeTaxPercent(TP): void {
    let val = (TP.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((TP.sorted || []).length) {
        this.TaxPercentFilter.orderColumn = TP.sorted[0].name;
        this.TaxPercentFilter.orderType = TP.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && TP.action.action != "clearFilter") {
      this.TaxPercentFilter.value = TP.action.currentFilterObject.value;
      this.TaxPercentFilter.field = TP.action.currentFilterObject.field;
      this.TaxPercentFilter.matchCase = TP.action.currentFilterObject.matchCase;
      this.TaxPercentFilter.operator = TP.action.currentFilterObject.operator;
      if(this.TaxPercentFilter.value == null || this.TaxPercentFilter.value == undefined || this.TaxPercentFilter.value == ''){
        this.TaxPercentFilter.value = "0";
      }
      if(this.TaxPercentFilter.field == "percent" || this.TaxPercentFilter.type == "number"){
        this.TaxPercentFilter.value = this.TaxPercentFilter.value.toString();
        this.TaxPercentFilter.type = "decimal";
      }
    }
    else {
      if (val == "filtering" && TP.action.action == "clearFilter") {
        this.TaxPercentFilter.field = "taxName";
        this.TaxPercentFilter.matchCase = false;
        this.TaxPercentFilter.operator = "contains";
        this.TaxPercentFilter.value = "";
        this.TaxPercentFilter.type = "string";
      }
    }
    this.getTaxPercentFilter();
    if (val == "paging" && TP.action.name == "actionBegin") {
    }
  }
  //.........................................onActionTaxpercent.....................................................
  public onActionTaxpercent(TP) {
    this.TaxPercentFilter.currentpageno = this.gridTaxPercent.pagerModule.pagerObj.currentPage;
    this.TaxPercentFilter.pageitem = this.gridTaxPercent.pagerModule.pagerObj.pageSize;
    if (TP.name == "actionBegin" && TP.requestType == "filterbeforeopen") {
      this.TaxPercentFilter.type = TP.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: saveTaxPercentageBO) {
    this.saveTaxPercentageInfo = JSON.parse(JSON.stringify(saveBos));
    this.saveTaxPercentageInfo.effectiveDate = this.datepipe.transform(this.saveTaxPercentageInfo.effectiveDate, "MM/dd/yyyy");
  }
  //............................................Refresh...................................................
  Refresh() {
    this.saveTaxPercentageInfo = new saveTaxPercentageBO();
    this.TaxPercentFilter = new GetTaxListBO();
    this.getTaxPercentFilter();

  }
  //...........................................DateFormat..........................................................
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'EffectiveDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.saveTaxPercentageInfo.effectiveDate = element;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'EffectiveDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.saveTaxPercentageInfo.effectiveDate = element;
        }
      }
    }
  }
  //.........................................getTaxPercentFilter.............................................
  getTaxPercentFilter() {
    this.DateListService.execute(this.TaxPercentFilter);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridTaxPercent.height = '500';
      }
      else {
        this.gridTaxPercent.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateTaxPercentList.............................................
  SaveOrUpdateTaxPercentList() {
    this.isSaveorUpdateBoolean=true;
    let savepayload: saveTaxPercentageBO = JSON.parse(JSON.stringify(this.saveTaxPercentageInfo));
    savepayload.id = this.saveTaxPercentageInfo.id;
    savepayload.effectiveDate = this.global.getDateTimeString(this.saveTaxPercentageInfo.effectiveDate)
    this.service.SaveTaxPercent(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById('openTaxPercentModal').click();
      this.isSaveorUpdateBoolean=false;
      if (data) {
        if (this.saveTaxPercentageInfo.id == '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Tax-percent saved successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);

        }
        else if (this.saveTaxPercentageInfo.id != '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Tax-percent updated successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }
        document.getElementById('openTaxPercentModal').click();
        this.saveTaxPercentageInfo = new saveTaxPercentageBO();
        this.getTaxPercentFilter();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }

  showTaxPercentColumns() {
    this.gridTaxPercent.columnChooserModule.openColumnChooser(200, 50);
  }

  //..........................................DeleteTaxPercnt...........................................................
  GetTaxListDD() {
    this.service.GetTaxListDD().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.TaskPercentdropdown = data;
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  //..........................................DeleteTaxPercnt...........................................................
  DeleteTaxPercent() {
    let params = new URLSearchParams();
    params.append("Id", this.saveTaxPercentageInfo.id);
    this.service.DeleteTaxPercent(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterservice.success('Tax-percent deleted successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('closeTaxPercentModal').click();
      this.getTaxPercentFilter();
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  clearTaxPercent() {
    this.saveTaxPercentageInfo = new saveTaxPercentageBO();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

